import { motion } from "framer-motion";

const STEPS = [
  {
    n: "01",
    title: "Pick your plan",
    body: "Choose Sole Trader or Company and the tier that fits. Pay securely with Stripe — cancel any time.",
  },
  {
    n: "02",
    title: "Connect your books",
    body: "Companies: invite us as your Xero advisor. Sole traders: we'll set you up on Prosaic — no Xero file required. We review, clean, and agree how things flow.",
  },
  {
    n: "03",
    title: "Get monthly tax emails",
    body: "After each month closes we email you your tax position, key numbers, and anything that needs your attention — in plain English.",
  },
];

export default function HowItWorks() {
  return (
    <section id="how" className="py-20 md:py-28 bg-slate-50 border-y border-slate-200" data-testid="how-section">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex items-end justify-between flex-wrap gap-6">
          <div>
            <div className="text-xs uppercase tracking-[0.22em] font-bold text-slate-500">How it works</div>
            <h2 className="mt-3 font-heading font-black text-4xl md:text-5xl tracking-tight leading-tight">
              From signup to your<br />first monthly email in days.
            </h2>
          </div>
          <a
            href="#pricing"
            className="inline-flex items-center gap-2 text-sm font-medium text-[#0A192F] hover:text-[#C9A349] transition-colors"
          >
            Jump to pricing →
          </a>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-px bg-slate-200 border border-slate-200">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: i * 0.08 }}
              className="bg-white p-8 md:p-12"
              data-testid={`step-${s.n}`}
            >
              <div className="font-heading font-black text-6xl text-[#C9A349] leading-none">{s.n}</div>
              <h3 className="mt-6 font-heading font-bold text-2xl">{s.title}</h3>
              <p className="mt-3 text-slate-600 leading-relaxed">{s.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
